import { PlanModelInfo, planTypes } from '@/common/constants';
import { planUnitMap } from '@/common/product-unit';
import { defaultMapper } from '@/common/service/default-mapper';

const workspaceReservationCategory = {
  workspace_reservation: {
    typeNameKey: 'billing.workspace_reservation.title',
    planNameKey: 'billing.workspace_reservation.title'
  }
};

export default (planMapJSON = {}) => {
  const cycleDepList = []
  const result = Object.keys(workspaceReservationCategory).reduce((pre, key) => {
    return [
      ...defaultMapper(planMapJSON[key], planTypes.WORKSPACE_RESERVATION).map(item => ({
        ...item,
        ...workspaceReservationCategory[key],
        billingCycleDependBasePlanTypeList: cycleDepList,
        standAlone: true,
        unit: planUnitMap.space,
        min: 1,
        max: 999,
        planModel: PlanModelInfo.license
      })),
      ...pre,
    ];
  }, []);
  return result;
}



